
export default {
  errorPageMessage: () => "We are sorry, the page you requested cannot be found.",
  errorPageSubMessage: () => "The URL may be misspelled or the page you're looking for is no longer available."
}